/**
 * resourceManagement模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceManagement = {
    /**************************AWS***************************/
  	//AWS数据库列表分页
  	selectAWSDatabaseByPage(params) {
    	return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSDatabaseByPage`,params);
  	},
   	//导出AWS数据库Excel文件
  	exportAWSDatabase(params) {
    	return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSDatabase`, params, {
      		responseType: 'arraybuffer',
      		timeout: 1000 * 60 * 20 // 接口响应事件设置为：20min
    	});
  	},
    //导出AWS数据库指标统计Excel文件
  	exportAWSDatabaseMetrics(params) {
    	return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSDatabaseMetric`, params, {
      		responseType: 'arraybuffer',
      		timeout: 1000 * 60 * 20 // 接口响应事件设置为：20min
    	});
  	},
     //AWS专用主机列表分页
     pagingQueryWSDedicatedHost(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryWSDedicatedHost`,params);
    },
    //导出AWS专用主机Excel文件
    exportAwsDedicatedHost(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsDedicatedHost`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS弹性负载均衡列表分页
    selectAWSLoadBalancerByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSLoadBalancerByPage`,params);
    },
    //导出AWS弹性负载均衡Excel文件
    exportAWSLoadBalancer(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSLoadBalancer`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS虚拟网络列表分页
    selectAWSVpcByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSVpcByPage`,params);
    },
    //导出AWS虚拟网络Excel文件
    exportAWSVpc(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSVpc`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS弹性IP列表分页
    selectAWSEipByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSEipByPage`,params);
    },
    //导出AWS弹性IPExcel文件
    exportAWSEip(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSEip`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS路由表列表分页
    selectAWSRouteTableByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSRouteTableByPage`,params);
    },
    //导出AWS路由表Excel文件
    exportAWSRouteTable(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSRouteTable`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS网关列表分页
    selectAWSGatewayByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSGatewayByPage`,params);
    },
    //导出AWS网关Excel文件
    exportAWSGateway(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSGateway`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS子网列表分页
    selectAWSSubnetByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSSubnetByPage`,params);
    },
    //导出AWS子网Excel文件
    exportAWSSubnet(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSSubnet`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS 实例列表分页
    selectAWSInstanceByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSInstanceByPage`,params);
    },
    //导出AWS 实例Excel文件
    exportAWSInstance(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSInstance`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    // 多行导出AWS 实例Excel文件
    exportAWSInstancesAndSecurityGroup(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSInstancesAndSecurityGroup`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //导出AWS实例指标统计Excel文件
    exportAWSInstanceMetrics(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSInstanceMetric`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS 弹性块存储分页
    pagingQueryVolume(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryVolume`,params);
    },
    //导出AWS 弹性块存储Excel文件
    exportVolume(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportVolume`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS 存储桶分页
    selectBucketByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectBucketByPage`,params);
    },
    //导出AWS 存储桶Excel文件
    exportAWSBucket(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSBucket`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS IAM user 列表分页
    selectAWSIamByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsIamUser`,params);
    },
    //导出AWS IAM Excel文件
    exportAWSIam(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsIamUser`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //AWS IAM 组列表分页
    pagingQueryAwsIamGroup(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsIamGroup`,params);
    },
    //导出AWS IAM Excel文件
    exportAwsIamGroup(params) {
        return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsIamGroup`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
        });
      },
    //AWS IAM 策略列表分页
    pagingQueryAwsIamPolicy(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsIamPolicy`,params);
    },
    //导出AWS IAM Excel文件
    exportAwsIamPolicy(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsIamPolicy`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //AWS IAM 策略列表分页
    pagingQueryAwsIamAKSK(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsIamAKSK`,params);
    },
    //导出AWS IAM Excel文件S
    exportAwsIamAKSK(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsIamAKSK`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //AWS redshift分页
    selectClusterByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectClusterByPage`,params);
    },
    //导出AWS redshiftExcel文件
    exportAWSCluster(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSCluster`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //AWS 安全组分页
    selectAWSSecurityGroup(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSSecurityGroup`,params);
    },
    //导出AWS 安全组Excel文件
    exportAWSSecurityGroup(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSSecurityGroup`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //导出AWS EKS Excel文件
    exportAwsEks(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsEks`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //AWS EKS分页
     pagingQueryAWSEks(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAWSEks`,params);
    },
    //导出AWS EMR Excel文件
    exportAwsEmr(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsEmr`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //AWS EMR分页
     pagingQueryAWSEmr(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAWSEmr`,params);
    },
     //导出AWS TGW Excel文件
     exportAwsTgw(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsTgw`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //AWS TGW 分页
     pagingQueryAwsTgw(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsTgw`,params);
    },

    //AWS 备份保管库分页
    selectAwsBackupVaultByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAwsBackupVaultByPage`,params);
    },
     //导出AWS备份保管库Excel文件
     exportAwsBackupVault(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsBackupVault`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //根据id获取备份保管库详情
    getBackupVaultDetails(params) {
    return $http({method:'post',url:`${global.API_URL}/sme/resourceAwsBackupVault/getBackupVaultDetails?id=` + params.id})
  },
   //AWS 备份计划分页
   selectAwsBackupPlanByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectAwsBackupPlanByPage`,params);
  },
   //导出AWS备份计划Excel文件
   exportAwsBackupPlan(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsBackupPlan`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
    });
  },
  //根据id获取备份计划详情
  getBackupPlanDetails(params) {
  return $http({method:'post',url:`${global.API_URL}/sme/resourceAwsBackupPlan/getBackupPlanDetails?id=` + params.id})
},

    /**************************Azure***************************/
    //Azure 虚拟机分页
    queryPagingAzureInstanceConfig(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/queryPagingAzureInstanceConfig`,params);
    },
    //导出Azure 虚拟机Excel文件
    exportAzureInstance(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureInstance`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //Azure存储账户列表分页
    selectAzureStorageAccountsByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAzureStorageAccountsByPage`,params);
    },
    //导出Azure存储账户Excel文件
    exportAzureStorageAccounts(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureStorageAccounts`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //Azure虚拟网络列表分页
    pagingQueryAzureVirtualNetwork(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAzureVirtualNetwork`,params);
    },
    //导出Azure虚拟网络Excel文件
    exportAzureVirtualNetwork(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureVirtualNetwork`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //Azure数据库分页
    queryPagingAzureDatabaseConfig(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/queryPagingAzureDatabaseConfig`,params);
    },
    //导出Azure数据库Excel文件
    exportAzureDatabase(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureDatabase`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //Azure托管磁盘分页
    queryPagingAzureDiskConfig(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/queryPagingAzureDiskConfig`,params);
    },
    //导出Azure托管磁盘Excel文件
    exportAzureDisk(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureDisk`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //导出Azure数据库Excel文件
    exportAzureDatabaseStatistics(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureDatabaseStatistics`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    /**************************ALi***************************/
        //ALi 实例列表分页
        selectAliyunInstanceByPage(params) {
          return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliyunInstanceByPage`,params);
        },
        //ALi数据库分页
        selectAliyunDatabaseByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliyunDatabaseByPage`,params);
        },
       //ALi弹性块存储分页
       pagingQueryAliVolume(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAliVolume`,params);
    },
      //导出ALi 弹性块存储Excel文件
    exportAliVolume(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliVolume`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //导出ALi数据库Excel文件
        exportAliyunDatabase(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliyunDatabase`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //导出ALi计算实例Excel文件
     exportAliyunInstance(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliyunInstance`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
      //ALi弹性IP分页
      selectAliyunEipByPage(params) {
        return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliyunEipByPage`,params);
      },
     //导出ALi弹性IPExcel文件
     exportAliEip(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliEip`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //ALi负载均衡分页
     selectAliLoadBalancerByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliLoadBalancerByPage`,params);
    },
    //导出ALi负载均衡Excel文件
    exportAliLoadBalancer(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliLoadBalancer`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      })
    },
    //导出ALi Cen Excel文件
    exportALiCen(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportALiCen`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
  //导出ALi Kafka Excel文件
  exportALiKafka(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportALiKafka`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },

     //ALi Cen分页
     selectALiCenByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectALiCenByPage`,params);
     },

    //ALi kafka分页
    selectALiKafkaByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectALiKafkaByPage`,params);
    },

  //====阿里ack(k8s)====start
  //阿里 ack(k8s)导出
  exportAliAck (params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliAck`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },

  //Ack(k8s)分页数据
  pagingQueryAliAck(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliAckByPage`,params);
  },

  //====阿里ack(k8s)====end



    //Redis分页数据
    pagingQueryAliRedis(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAliRedis`,params);
    },
    //Redis导出
    exportAliRedis (params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliRedis`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //Vpc分页数据
    selectAliVpcByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliVpcByPage`,params);
    },
    //Vpc导出
    exportAliVpc(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliVpc`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //Ali Waf分页数据
    selectALiWafByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectALiWafByPage`,params);
  },
    //Ali Waf导出
    exportAliWaf(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliWaf`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
    //Oss分页数据
    pagingQueryAliOss(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAliOss`,params);
    },
    //OSS导出
    exportAliOss(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliOss`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //NatGateway分页数据
    pagingQueryAliNatGateway(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAliNatGateway`,params);
    },
    //NatGateway导出
    exportAliNatGateway(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliNatGateway`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //导出数据库健康统计Excel文件
    exportDatabaseStatistics(params) {
      return $http.post(`${global.API_URL}/sme/rds/exportDatabaseStatistics`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //导出实例健康统计Excel文件
    exportInstanceStatistics(params) {
      return $http.post(`${global.API_URL}/sme/instance/exportInstanceStatistics`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //导出磁盘健康统计Excel文件
    exportDiskStatistics(params) {
      return $http.post(`${global.API_URL}/sme/volume/exportDiskStatistics`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    //导出Azure应用程序服务Excel文件
    exportAzureAppService(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureAppService`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //应用程序服务分页
    queryPagingAzureWebAppConfig(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/queryPagingAzureWebAppConfig`,params);
    },  //Azure负载均衡列表分页
     selectAzureLoadBalancerByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAzureLoadBalancerByPage`, params);
    },
    //导出Azure负载均衡Excel文件
     exportAzureLoadBalance(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAzureLoadBalance`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
      });
    },
    //立即更新资源
    updateResource(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/updateResource`,params);
    },
    //分页查询AWS Elasticsearch
    selectAWSElasticsearchByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAWSElasticsearchByPage`, params);
    },
    //导出AWS Elasticsearch Excel文件
    exportAWSElasticsearch(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSElasticsearch`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },
    // ElastiCache 相关接口
    selectAwsElastiCacheByPage (params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAwsElastiCache`,params);
    },
    exportAwsElastiCache (params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAwsElastiCache`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    // ebsSnapshot分页
    pagingQueryAWSSnapshot (params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAWSSnapshot`,params);
    },
    // ebsSnapshot导出
    exportAWSSnapshot (params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSSnapshot`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    // natGateway 分页
    pagingQueryAWSNatGateway (params) {
        return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAWSNatGateway`,params);
    },
    // natGateway 导出
    exportAWSNatGateway (params) {
        return $http.post(`${global.API_URL}/sme/resourceManagement/exportAWSNatGateway`, params, {
            responseType: 'arraybuffer',
            timeout: 1000 * 60 * 20
        });
    },

    //弹性伸缩分页数据
    selectAliAutoScalingGroupByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectAliAutoScalingGroupByPage`,params);
    },
    //弹性伸缩导出
    exportAliAutoScalingGroup(params) {
        return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliAutoScalingGroup`, params, {
            responseType: 'arraybuffer',
            timeout: 1000 * 60 * 20
        });
    },

    //loggingstored分页数据
    selectGcpLoggingStoredGroupByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectGCPLoggingBucketsByPage`,params);
    },
    //loggingstored导出
    exportGcpLoggingStoredGroup(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGCPLoggingBuckets`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
      });
    },

  //logging route分页数据
  selectGcpLoggingRouteGroupByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectGCPLoggingSinksByPage`,params);
  },
  //logging route导出
  exportGcpLoggingRouteGroup(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportGCPLoggingRoute`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
    //SLS分页数据
    pagingQueryAliSls(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryAliSls`,params);
    },
    //SLS导出
    exportAliSls(params) {
        return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliSls`, params, {
            responseType: 'arraybuffer',
            timeout: 1000 * 60 * 20
        });
    },

  // ClickHouse 分页查询
  pagingQueryAliClickHouse(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectALiClickhouseByPage`,params);
  },
  // ClickHouse 条件导出
  exportAliClickHouse(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportAliClickhouse`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },

  // ECS 预留实例劵 分页查询
  pagingQueryAliEcsReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectALiEcsReservedInstanceByPage`,params);
  },
  // ECS 预留实例劵 条件导出
  exportAliEcsReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportALiEcsReservedInstance`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },

     /**************************Gcp***************************/

     //导出Gcp计算实例Excel文件
     exportGCPInstance(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGCPInstance`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //GCP 实例列表分页
     selectGCPInstanceByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectGCPInstanceByPage`,params);
    },
     //导出GCP 弹性块存储Excel文件
     exportGcpDisk(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGcpDisk`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //RDS弹性块存储分页
     pagingQueryGcpDisk(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryGcpDisk`,params);
    },
    //RDS数据库分页
      selectGCPCloudSQLByPage(params) {
       return $http.post(`${global.API_URL}/sme/resourceManagement/selectGCPCloudSQLByPage`,params);
    },
    //RDS数据库导出
    exportGCPCloudSQL(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGCPCloudSQL`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
     //GCP负载均衡导出
    exportGcpLoadBalancer(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGcpLoadBalancer`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //GCP负载均衡分页
    selectGcpLoadBalancerByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectGcpLoadBalancerByPage`,params);
   },
     //GCPCloudStorageGcp导出
     exportGCPCloudStorage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGCPCloudStorage`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },
    //GCPCloudStorageGcp分页
    selectGCPCloudStorageByPage(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/selectGCPCloudStorageByPage`,params);
   },
   //GCPdRedis导出
   exportGcpRedis(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportGcpRedis`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 20
    });
  },
   //Redis分页数据
   pagingQueryGcpRedis(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryGcpRedis`,params);
  },

     //导出GCP BigQueryExcel文件
     exportGCPBigQuery(params) {
      return $http.post(`${global.API_URL}/sme/resourceManagement/exportGCPBigQuery`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 20
      });
    },

   //BigQuery分页数据
   selectGCPBigQuery(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectGCPBigQuery`,params);
  },

  // Kubernetes START REGION
  // 分页条件查询 gcp gke
  pagingQueryGcpGke(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/pagingQueryGcpGke`,params);
  },
  // 条件导出 gcp gke
  exportGcpGke(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportGcpGke`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // Kubernetes END REGION

  // Filestore START REGION
  // 分页条件查询
  selectFileStoreByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectFileStoreByPage`,params);
  },
  // 条件导出
  exportFileStore(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportFileStore`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  /**************************华为云***************************/
  // 导出华为云服务器Excel文件
  exportHWCInstance(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportHuaweiInstance`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 导出华为云数据库Excel文件
  exportHWCDatabase(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportHuaweiDatabase`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  //华为云 云服务器列表
  selectHWCInstanceByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectHuaweiInstanceByPage`,params);
  },
  // 华为云 云数据库列表
  selectHWCCloudDatabaseByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectHuaweiCloudDatabaseByPage`,params);
  },
  // 华为云EVS & OBS接口
  selectHWCVolumeByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectHuaweiCloudVolumeByPage`,params);
  },
  exportHWCVolume(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportHuaweiVolume`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  selectHWCBucketByPage(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/selectHuaweiCloudBucketByPage`,params);
  },
  exportHWCBucket(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/exportHuaweiBucket`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  /**************************腾讯云***************************/
  // 腾讯云资源更新（独立入口）
  updateTencentResource(params) {
    return $http.post(`${global.API_URL}/sme/resourceManagement/updateTencentResource`, params);
  },
  // CVM 云服务器
  selectTencentCvmByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cvm/page`, params);
  },
  exportTencentCvm(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cvm/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 云数据库 MySQL（CDB）
  selectTencentCdbByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cdb/page`, params);
  },
  exportTencentCdb(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cdb/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 云数据库 PostgreSQL
  selectTencentPostgresByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/postgres/page`, params);
  },
  exportTencentPostgres(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/postgres/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 云数据库 Redis
  selectTencentRedisByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/redis/page`, params);
  },
  exportTencentRedis(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/redis/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 云硬盘（CBS）
  selectTencentCbsByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cbs/page`, params);
  },
  exportTencentCbs(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cbs/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 负载均衡（CLB）
  selectTencentClbByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/clb/page`, params);
  },
  exportTencentClb(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/clb/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 对象存储（COS）
  selectTencentCosByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cos/page`, params);
  },
  exportTencentCos(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/cos/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 私有网络（VPC）
  selectTencentVpcByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/vpc/page`, params);
  },
  exportTencentVpc(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/vpc/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 子网（Subnet）
  selectTencentSubnetByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/subnet/page`, params);
  },
  exportTencentSubnet(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/subnet/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 安全组（SG）
  selectTencentSgByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/sg/page`, params);
  },
  exportTencentSg(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/sg/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  },
  // 弹性IP（EIP）
  selectTencentEipByPage(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/eip/page`, params);
  },
  exportTencentEip(params) {
    return $http.post(`${global.API_URL}/sme/tencentResource/eip/export`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 20
    });
  }
  // Tencent END REGION
}

export default resourceManagement;



// WEBPACK FOOTER //
// ./src/api/resourceManagement.js